import closeIcon from "@assets/search/close.svg";
import searchLogo from "@assets/search/searchLogo.svg";

type SearchButtonProps = {
  onClick: () => void;
  expanded: boolean;
};

export function SearchButton({ onClick, expanded }: SearchButtonProps) {
  return (
    <>
      <button data-testid="searchButton" onClick={onClick}>
        <img
          src={expanded ? closeIcon : searchLogo}
          alt="search-logo"
          loading="lazy"
          width="24"
          height="24"
        />
      </button>
    </>
  );
}
